<div class="main-box text-center">
  <h1 class="cr-header">Welcome to Park Evaluations</h1>
  <div class="mt-4 alert alert-success font-weight-bold cr-alert">
    This link has been already used to setup an account
  </div>
  <hr>
  <div class="text-muted">Please use the button below to login with the password created for this account</div>
  <button type="button" class="btn btn-primary w-25 mt-4" routerLink="../login">
    Login Page
  </button>
</div>
